import { FlagValue } from '@openfeature/web-sdk'
import {
  FeatureFlagValues,
  FlagDefinitions,
  FlagDefinition,
  OpenFeatureFlag,
} from './types'

/**
 *
 * @param flagDefinitions
 * @param calculateFn
 */
function toDerivedConfig<T extends FlagDefinitions, C>(
  flagDefinitions: T,
  calculateFn: (val: FlagDefinition<any>) => C
): { [key: string]: C } {
  return Object.fromEntries(
    Object.keys(flagDefinitions).map((key) => [
      key,
      calculateFn(flagDefinitions[key]),
    ])
  )
}
/**
 *
 * @param val
 */
function definitionToOpenFeatureSpec(
  val: FlagValue
): OpenFeatureFlag<FlagValue> {
  const offVal = typeof val === 'boolean' ? false : null

  return {
    variants: {
      on: val,
      off: offVal,
    },
    disabled: false,
    defaultVariant: val ? 'on' : 'off',
  }
}
/**
 *
 * @param flagDefinitions
 * @param k
 */
export function getOpenFeatureSpecs<T extends FlagDefinitions>(
  flagDefinitions: T,
  k: 'local' | 'fallback'
): { [key: string]: OpenFeatureFlag<FlagValue> } {
  return toDerivedConfig(flagDefinitions, (definition) =>
    definitionToOpenFeatureSpec(definition[k])
  )
}
/**
 *
 * @param flagDefinitions
 */
export function getFallbackValues<T extends FlagDefinitions>(
  flagDefinitions: T
): FeatureFlagValues<T> {
  return toDerivedConfig(
    flagDefinitions,
    (definition) => definition.fallback
  ) as FeatureFlagValues<T>
}
